<template>
  <div class="areas-arvore-item">
    <div
      class="d-flex align-items-center areas-arvore-name cursor"
      v-b-toggle="area.children ? 'tree-item-' + area.id : ''"
      @click="clicked = !clicked"
      style="position: relative"
    >
      <span
        v-if="showOrHidenArrow"
        class="arrow"
        :class="[clicked ? 'arrow-down' : 'arrow-right']"
      ></span>
      <span>
        {{ area.nome }}
        <slot :status="area.status" name="status"></slot>
      </span>

      <Actions
        :item="area"
        :view_show="false"
        :view_edit="$can('area:edit')"
        :view_delete="$can('area:delete')"
        edit_to="areas_edit"
        @delete="delete_area"
      />
    </div>

    <b-collapse :id="'tree-item-' + area.id">
      <div
        v-for="(area_child, key) in area.children"
        :key="key"
        class="areas-arvore-children"
      >
        <arvore-item :area="area_child">
          <template #status="status">
            <b-badge
              pill
              variant="warning"
              class="ml-3 px-2"
              v-if="!status.status"
              >{{ "Inativo" }}</b-badge
            >
          </template>
        </arvore-item>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";

import { mapActions } from "vuex";

export default {
  name: "arvore-item",
  components: { Actions },
  props: {
    area: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      clicked: false,
    };
  },

  computed: {
    showOrHidenArrow() {
      if (this.area.children && this.area.children.length > 0) {
        return true;
      }
      return false;
    },
  },

  methods: {
    ...mapActions("areas", ["ActionDelete"]),
    async delete_area(area) {
      try {
        await this.ActionDelete(area.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
  },
};
</script>

<style>
.cursor {
  cursor: pointer;
}

.arrow {
  margin-right: 24px !important;
  position: relative;
}

.arrow-right::before {
  font-family: "FontAwesome";
  content: "\f0da";
  font-weight: 400;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.arrow-down::before {
  font-family: "FontAwesome";
  content: "\f0d7";
  font-weight: 400;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
